<template>
    <div class="component__location">
        <h2 class="component__location_title">{{ $t('shared.components.title.location') }}</h2>
        <div class="component__location_address">
            <component-address :address="address"/>
        </div>
        <div class="component__location_map">
            <template v-if="formattedAddress">
                <component-map
                    :address="address"
                />
            </template>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import ComponentMap from '@/components/default/shared/ComponentMap'
import ComponentAddress from '@/components/default/shared/ComponentAddress'

export default {
  components: {
    ComponentAddress,
    ComponentMap },
  name: 'show-location',
  props: {
    address: {
      type: [Array, Object],
      default: () => {
      },
      required: true
    }
  },
  computed: {
    formattedAddress: function () {
      if (this.address.type === 'automatic') {
        return this.address.formatted_address
      } else {
        return `${this.address.address_1} ${this.address.address_2} ${this.address.city} ${this.address.postcode} ${this.address.county} ${this.address.country}`
      }
    },
    googleMapKey: function () {
      return api.googlekey
    },
    googleMapQuery: function () {
      const address = this.formattedAddress
      return address.replace(/\s+/g, '+')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentlocation";
</style>
